import { WorkOrderAssetsTabState } from "./work-order-assets-tab-state.interface";

export function createWorkOrderAssetsTabState(): WorkOrderAssetsTabState {
  return {
    assets: null,
    isLoading: false,
  };
}
